import React, { useEffect, useState } from "react";
import PropTypes from "prop-types";
import {
  Drawer,
  IconButton,
  ListItem,
  ListItemText,
  Typography,
  Box,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
} from "@mui/material";
import { ArrowBack } from "@mui/icons-material";
import { makeStyles } from "@mui/styles";
import { AppConstant, KeyConstant, SystemConstant } from "const";
import clsx from "clsx";
import TestFailed from "../pages/HomePage/components/Account/TestFailed";
import { StorageUtil, convertString2JSON } from "utils";
import { getInteractor } from "services/local.service";

const AppDrawer = ({
  title,
  children,
  icon,
  isPadding,
  onClose,
  classes,
  secondIcon,
  secondIconProps,
  ...drawerProps
}) => {
  const defaultClasses = useStyles();
  const [clickCount, setClickCount] = useState(0);
  const [openPopup, setOpenPopup] = useState(false);
  const prefixKey = StorageUtil.getCurrentPrefixKey();
  const accountId = StorageUtil.getItem(KeyConstant.KEY_ACCOUNT_ID, prefixKey);
  const branchId = StorageUtil.getItem(KeyConstant.KEY_BRANCH_ID, prefixKey);

  const [hiddenF, setHiddenF] = useState({});
  const getHiddenF = async () => {
    const account = await getInteractor(prefixKey).LocalAccountService.get(accountId, branchId);
    const accountOption = account?.options ? convertString2JSON(account?.options) : {};
    setHiddenF(accountOption?.hidden_f || SystemConstant.ACCOUNT_HIDDEN_F.display);
  };

  useEffect(() => {
    getHiddenF(accountId, branchId);
  }, [accountId, branchId]);

  const handleTitleClick = () => {
    if (hiddenF !== SystemConstant.ACCOUNT_HIDDEN_F.display) return;
    const newCount = clickCount + 1;
    if (newCount >= 10) {
      setOpenPopup(true);
      setClickCount(0); // reset lại nếu muốn click tiếp tục
    } else {
      setClickCount(newCount);
    }
  };

  const handleClosePopup = () => setOpenPopup(false);

  return (
    <Drawer
      anchor="left"
      classes={{
        root: clsx(defaultClasses.drawer, classes.root),
        paper: clsx(defaultClasses.paper, classes.paper),
      }}
      hideBackdrop={true}
      onClose={onClose}
      disableAutoFocus
      disableEnforceFocus
      {...drawerProps}
    >
      <ListItem>
        <IconButton onClick={onClose} edge="start" className={defaultClasses.btnBack}>
          {icon || <ArrowBack />}
        </IconButton>
        <ListItemText
          primary={
            <Typography onClick={handleTitleClick} className={clsx(defaultClasses.drawerTitle, classes.title)}>
              {title}
            </Typography>
          }
        />
        {secondIcon && (
          <IconButton edge="end" className={defaultClasses.btnBack} {...secondIconProps}>
            {secondIcon}
          </IconButton>
        )}
      </ListItem>

      <Box overflow="auto" className={clsx(isPadding && defaultClasses.drawerPadding, classes.wrapper)}>
        {children}
      </Box>
      <Dialog open={openPopup} onClose={handleClosePopup}>
        <DialogTitle>Test lỗi</DialogTitle>
        <DialogContent> {<TestFailed />}</DialogContent>
        <DialogActions>
          <Button onClick={handleClosePopup} color="primary">
            Đóng
          </Button>
        </DialogActions>
      </Dialog>
    </Drawer>
  );
};

AppDrawer.propTypes = {
  title: PropTypes.string,
  open: PropTypes.bool,
  icon: PropTypes.node,
  anchor: PropTypes.string,
  isPadding: PropTypes.bool,

  classes: PropTypes.shape({
    root: PropTypes.string,
    paper: PropTypes.string,
    wrapper: PropTypes.string,
  }),

  onClose: PropTypes.func,
};

AppDrawer.defaultProps = {
  classes: {
    root: "",
    paper: "",
  },
  isPadding: false,
};

export default AppDrawer;

const useStyles = makeStyles(theme => ({
  drawer: {
    "&, & $paper": {
      width: AppConstant.SIDEBAR_WIDTH.medium,
      flexShrink: 0,
      boxShadow: "unset",

      [theme.breakpoints.up(1500)]: {
        width: AppConstant.SIDEBAR_WIDTH.large,
      },
    },
  },

  paper: {
    paddingTop: 8,
  },

  btnBack: {
    color: "#424242",
  },

  drawerTitle: {
    fontWeight: 700,
    fontSize: 15,
    color: theme.palette.black,
    textAlign: "center",
  },

  drawerPadding: {
    paddingLeft: 16,
    paddingRight: 16,
  },
}));
